module.exports = __webpack_public_path__ + "img/incineroar-min.2f9c1aae.png";